import React from "react";
import { ErrorBoundary } from "./ui/ErrorBoundary";
import { AuthProvider, useAuth } from "./ui/context/AuthContext";
import { Login } from "./ui/Login";
import { Shell } from "./ui/Shell";
import type { Session, Role } from "./ui/auth";

// ✅ 只有在你手動開啟才 bypass
const DEV_BYPASS_LOGIN = (import.meta as any)?.env?.VITE_DEV_BYPASS_LOGIN === "1";

function AppContent() {
  const bootErr = (window as any).__BOOT_ERR__;
  const { user, isAuthenticated, logout } = useAuth();

  // ✅ bypass：直接給一個假的 session 讓 Shell 跑起來
  if (DEV_BYPASS_LOGIN) {
    const session: Session = {
      username: "dev@local",
      role: ("super" as unknown) as Role,
      displayName: "DEV-BYPASS",
      loggedInAt: Date.now(),
    };
    return <Shell session={session} onLogout={() => {}} bootErr={bootErr} />;
  }

  // 正常流程：沒登入就回登入頁
  if (!isAuthenticated || !user) {
    return <Login bootErr={bootErr} />;
  }

  const session: Session = {
    username: user.email,
    role: (user.role as unknown) as Role,
    displayName: user.displayName || user.name || user.email,
    loggedInAt: Date.now(),
  };

  return <Shell session={session} onLogout={() => logout()} bootErr={bootErr} />;
}

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ErrorBoundary>
  );
}
